import React from "react";
import { Doughnut } from "react-chartjs-2";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

const chartData = {
  labels: ["USA", "UK", "CA"],
  datasets: [
    {
      data: [300, 50, 100],
      borderColor: [
        colors.ReactifyChartColor1,
        colors.ReactifyChartColor2,
        colors.ReactifyChartColor3
      ],
      borderWidth: 2,
      backgroundColor: [
        colors.foregroundColor,
        colors.foregroundColor,
        colors.foregroundColor
      ],
      hoverBackgroundColor: [
        colors.foregroundColor,
        colors.foregroundColor,
        colors.foregroundColor
      ]
    }
  ]
};

function DoughnutChart() {
  return (
    <div>
      <Doughnut data={chartData} />
    </div>
  );
}

export default DoughnutChart;
